import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { IRoleSymbols } from 'app/models/permission.model';
import { RoleLegendEntry, accountStateLegend, roleLegend, storedFeatureEnabled } from './role-symbol';

/**
 * Legend of the role symbols: the customer's built-in roles and custom roles (ES-7564). Used by Staff
 * Management and the alarm route recipient selection, so both explain the symbols the same way.
 */
@Component({
  selector: 'role-legend',
  template: `
    @for (entry of entries; track entry.key) {
      <span class="role-legend-entry">
        <span class="fa-fw" [ngClass]="entry.classes" [attr.data-testid]="entry.testId"></span>
        <small> = {{ entry.nameKey ? (entry.nameKey | translate) : entry.name }}</small>
      </span>
    }
  `,
  styles: [`
    :host { display: flex; flex-wrap: wrap; align-items: baseline; row-gap: 0.25rem; }
    .role-legend-entry { margin-left: 0.5rem; white-space: nowrap; }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, TranslateModule],
})
export class RoleLegendComponent implements OnChanges {
  /** Custom roles of the customer; built-in roles are shown without */
  @Input() symbols: IRoleSymbols | null = null;
  /** Level of the logged-in user (Everon admins also see EMAAC accounts) */
  @Input() userLevel: number | undefined;
  /** Explain the login identity shield: the listed staff include someone with a login identity */
  @Input() showIdentity = false;
  /** Customer features; defaults to the features stored at login */
  @Input() featureEnabled: (feature: string) => boolean = storedFeatureEnabled;

  entries: RoleLegendEntry[] = roleLegend(storedFeatureEnabled, undefined, null);

  ngOnChanges(): void {
    const featureEnabled = this.featureEnabled ?? storedFeatureEnabled;
    this.entries = [...roleLegend(featureEnabled, this.userLevel, this.symbols), ...accountStateLegend(this.showIdentity)];
  }
}
